var _title, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoBuildkite = function SvgLogoBuildkite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 500 334"
    },
    viewBox: "0 0 500 334"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Buildkite")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#30f2a2",
    d: "M0 0v166.6L166.7 250V83.3L0 0zm333.3 0v166.6L500 83.3 333.3 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#14cc80",
    d: "M333.3 166.7v166.6L500 250V83.3l-166.7 83.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#14cc80",
    d: "M166.7 83.3V250l166.7-83.3V0L166.7 83.3z"
  })));
};
export default SvgLogoBuildkite;